<div class="row fichas">
    <br>
    <h4 class="col-12 subtitle-trends pt-3" *ngIf="sector">Tendencias para el sector {{sector.longname}}</h4>

    <div class="textOnInput col-12" *ngFor="let f of filteredTier1">
        <div *ngIf="f.tier3.length > 0">
            <label class="form-label" for="inputText">
                {{ f.idTier1 === 5 ? 'Tendencias nacionales vinculadas con el sector ' + sector.longname : 'Tendencias sectoriales' }}
            </label>
            <div class="div-container py-3">
                <div class="col-6 col-sm-4 col-md-3 col-elements" *ngFor="let p of f.tier3">
                    <div class="card-elements" routerLink="../../ficha/{{p.code}}">
                        <div class="btn-trends">
                            <i class="fa fa-location-arrow" aria-hidden="true"></i>
                            <div class="box-text-btn">{{p.shorttitle}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-container *ngIf="docsector && docsector.length > 0; else noDocumentsMessage">
    <div class="col-12">
        <hr>
        <p *ngFor="let ds of docsector">Descargue el reporte completo
            <a *ngIf="ds.url.startsWith('http')" class="underline" href="{{ds.url}}" target="_blank">aquí.</a>
            <a *ngIf="ds.url.startsWith('/uploads')" class="underline" href="{{URLObs}}{{ds.url}}" target="_blank">aquí.</a>
        </p>
    </div>
</ng-container>
<ng-template #noDocumentsMessage>
    <hr>
    <p *ngIf="sector">Pronto compartiremos el reporte sectorial de {{sector.longname}} para su descarga.</p>
</ng-template>
